import * as Sentry from "@sentry/react-native";
import ToastMessage from "@components/Toast";
import { actions as delayedActions } from "@reducers/delayDataReducer";
import { postCpAvailability } from "@services/api/CpAvailability";
import { Platform, UIManager } from "react-native";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import analytics from "./analytics";

if (Platform.OS === "android") {
  if (UIManager.setLayoutAnimationEnabledExperimental) {
    UIManager.setLayoutAnimationEnabledExperimental(true);
  }
}

const useCpAvailability = () => {
  const { modal, chip } = useSelector(
    (state) => state.delayedDataReducer?.cpAvailabilityModal,
    shallowEqual,
  );

  const dispatch = useDispatch();

  const _onPress = (resp) => () => {
    postCpAvailability({ response: resp })
      .then(({ data }) => {
        const toastMessage =
          resp === modal.cta_right_key
            ? modal.cta_right_success_text
            : modal.cta_left_success_text;
        if (toastMessage) {
          ToastMessage("simple", toastMessage, 3000, "bottom");
        }
        dispatch(delayedActions.updateCpAvailabilityModal(data));
      })
      .catch((e) => {
        Sentry.captureException(e);
        dispatch(delayedActions.updateCpAvailabilityModal({}));
      });
    analytics.modalAction({
      title: modal.title,
      cta: resp,
      source: "home",
    });
  };

  return {
    _onPress,
    visible: !!modal && !modal.is_submitted,
    chip,
    modal,
  };
};

export default useCpAvailability;
